import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

interface TreeNode {
  id: number;
  name: string;
  Atividade: string;
  EDT: string;
  description: string;
  status: string;
  employees: string;
  budget: string;
  inicio: string;
  fim: string;
  children?: TreeNode[];
  expanded?: boolean; // Controle para expandir/colapsar
}

interface CronogramaEmpresa {
  id: number;
  nome: string;
  dataCriacao: string;
}

// Exemplo de dados com mais campos
/*const TREE_DATA: TreeNode[] = [
  {
    id: 1,
    name: 'Cadastro',
    Atividade:"",
    EDT: "",
    description: '60%',
    status: 'Inativo',
    employees: '01/10/2024',
    budget: '01/09/2025',
    children: [
     
      {
        id: 4,
        name: '',
        Atividade:"Empresa",
        EDT: "",
        description: '60%',
        status: 'Inativo',
        employees: '01/10/2024',
        budget: '01/10/2025',
      },
      {
        id: 5,
        name: '',
        Atividade:"Responsável Técnico",
        EDT: "",
        description: '100%',
        status: 'Ativo',
        employees: '01/10/2024',
        budget: '01/10/2025',
      },
    ],
  },
  {
    id: 6,
    name: 'Qualificação Documental',
    Atividade:"",
    EDT: "",
    description: '100%',
    status: 'Ativo',
    employees: '01/10/2024',
    budget: '15/12/2025',
    children: [{ id: 7, name: '',   Atividade:"Licenças", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
      ,{ id: 8, name: '',   Atividade:"Alvarás", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
      ,{ id: 9, name: '',   Atividade:"Laudos", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
    ],
  },
  {
    id: 10,
    name: 'Auto Auditoria',
    Atividade:"",
    EDT: "",
    description: '100%',
    status: 'Ativo',
    employees: '01/10/2024',
    budget: '15/12/2025',
    children: [
      { id: 11, name: '', Atividade:"CheckList", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
      ,{ id: 12, name: '', Atividade:"Planos de Ações", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }

    ],
  },
  {
    id: 7,
    name: 'Auditoria de Qualificação',
    Atividade:"",
    EDT: "",
    description: '100%',
    status: 'Ativo',
    employees: '01/10/2024',
    budget: '15/12/2025',
    children: [
      { id: 6, name: '', Atividade:"CheckList", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
      ,{ id: 6, name: '', Atividade:"Planos de Ações", EDT: "", description: '100%', status: 'Ativo', employees: '01/10/2024', budget: '15/12/2025' }
    
    ],
  }
];*/


@Component({
  selector: 'app-home-programa',
  templateUrl: './home-programa.component.html',
  styleUrls: ['./home-programa.component.scss']
})
export class HomeProgramaComponent implements OnInit {
  dataSource = [];
  cronogramas: CronogramaEmpresa[] = [];
  cronogramaSelecionado: number | null = null;
  idEmpresa: number;

  constructor(
    private ajax: AjaxService,
    private util: UtilService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idEmpresa = +params['ID_EMPRESA'];
      if (this.idEmpresa) {
        this.carregarCronogramasEmpresa();
      }
    });
  }

  carregarCronogramasEmpresa() {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa?ID_EMPRESA=${this.idEmpresa}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cronogramas = response.data;
            if (this.cronogramas.length > 0) {
              this.cronogramaSelecionado = this.cronogramas[0].id;
              this.carregarCronogramaVisaoGeral();
            }
          } else {
            this.cronogramas = [];
            console.log('Nenhum cronograma encontrado');
          }
        },
        error: (error) => {
          this.util.closeLoading();
          console.error('Erro ao carregar cronogramas:', error);
        }
      });
  }

  carregarCronogramaVisaoGeral() {
    if (!this.cronogramaSelecionado) return;

    this.util.showLoading();
    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa/buscarCronogramaVisaoGeral?ID_CRONOGRAMA_EMPRESA=${this.cronogramaSelecionado}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.dataSource = response.data[0].children;
          } else {
            this.dataSource = [];
            console.log('Nenhum dado encontrado para o cronograma selecionado');
          }
        },
        error: (error) => {
          this.util.closeLoading();
          console.error('Erro ao carregar cronograma:', error);
        }
      });
  }

  onCronogramaChange() {
    this.carregarCronogramaVisaoGeral();
  }

  // Alterna a expansão do nó
  toggleExpand(node: TreeNode) {
    node.expanded = !node.expanded;
  }
}
